import React, {memo} from 'react';
import {NameDialog, NameDialogProps} from './NameDialog';

export type InputDialogData = Omit<NameDialogProps, 'onClose'>;
type Props = {
   data: InputDialogData;
   onClose: NameDialogProps['onClose'];
};
const InputDialog = memo(({data, onClose}: Props) => {
   return <NameDialog {...data} onClose={onClose} />;
});

export default InputDialog;
